/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2019, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/

import {
  Component, EventEmitter, Inject, Input, OnInit, Output,
} from '@angular/core';
import { generateObjectId } from '../../../app/exports';
import { isRequired } from './utils';

/**
 * Component for our Aero Image Radio Group Button.
 */
@Component({
  selector: 'aero-image-radio-button',
  templateUrl: './aero-image-radio-button.component.html',
  standalone: false,
})
export class AeroImageRadioButtonComponent implements OnInit {
  /**
   * Finalized Radio Image after selection
   */
  public radioImage : {
    id : string,
    src : string
  };

  /**
   * Optional input parameter for input name.
   */
  @Input() name? : string;

  /**
   * Optional input parameter for input value.
   */
  @Input() value? : any;

  /**
   * Optional parameter that specifies the width of the image.
   */
  @Input() width? : number;

  /**
   * Optional parameter that specifies the height of the image.
   */
  @Input() height? : number;

  /**
   * Input property that is two way binding from the parent image-radio-group component.
   */
  @Input() selectedImageId : any;

  /**
   * Output property to propagate the selected image back up to the parent component.
   */
  @isRequired
  @Output() selectedImageIdChange = new EventEmitter();

  /**
   * Image source / path.
   */
  @isRequired
  @Input() imageSrc : string;

  /**
   * Default constructor.
   */
  constructor(@Inject('BulbBrowserService') private BulbBrowserService : any) {}

  ngOnInit() {
    const isMobile = this.BulbBrowserService.isIOSMobile() || this.BulbBrowserService.isAndroid();
    // Setting up width and height if provided, if not default to finalized values.
    this.width = (this.width) ? this.width : (!isMobile) ? 132 : 88;
    this.height = (this.height) ? this.height : (!isMobile) ? 170 : 112;
    // Generate radio Image, given it a unique Id:
    this.radioImage = {
      id: generateObjectId(),
      src: this.imageSrc,
    };
  }

  /**
   * ngModel Change method to handle updating the model value from the view.
   * @param newValue
   */
  change(newValue) : void {
    this.selectedImageId = newValue;
    this.selectedImageIdChange.emit(newValue);
  }
}
